import { type FC } from 'react';
import { UiSimpleGrid, UiStack, UiText } from '@/lib/ui';
import BaseCardGroup from '@/base/CardGroup';
import BaseCardGroupItem from '@/base/CardGroup/Item';
import { type RegistrationInfo } from '@/api/registration';

export interface TicketsProps {
  registration: RegistrationInfo
}

const Tickets: FC<TicketsProps> = ({ registration }) => {
  const getTicketTypeLabel = (type: string): string => {
    switch (type) {
      case 'function': return 'Function';
      case 'workshop': return 'Workshop';
      case 'tour': return 'Tour';
      default: return 'Session';
    }
  };

  const hasTickets = registration.delegateType || (registration.sessionUsers && registration.sessionUsers.length > 0);

  return (
    <UiStack spacing={4}>
      <UiText variant={'title'}>Tickets</UiText>
      {hasTickets ? (
        <BaseCardGroup p={8}>
          <UiSimpleGrid columns={3} gap={8}>
            {registration.delegateType && (
              <BaseCardGroupItem p={8}>
                <UiStack spacing={4}>
                  <UiText>Registration type: {registration.delegateType}</UiText>
                </UiStack>
              </BaseCardGroupItem>
            )}

            {registration.sessionUsers?.map((session) => {
              return (
                <BaseCardGroupItem key={session.id} p={8}>
                  <UiStack spacing={4}>
                    <UiText>{getTicketTypeLabel(session.sessionType)}: {session.name}</UiText>
                  </UiStack>
                </BaseCardGroupItem>
              );
            })}
          </UiSimpleGrid>
        </BaseCardGroup>
      ) : (
        <BaseCardGroup p={8}>
          <UiText color={'text.secondary'}>No tickets found</UiText>
        </BaseCardGroup>
      )}
    </UiStack>
  );
};

export default Tickets;
